import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaFilePdf } from 'react-icons/fa';

const SocialIcons = () => {
  return (
    <div className="fixed right-4 sm:right-6 top-1/2 -translate-y-1/2 flex flex-col gap-4 sm:gap-6 z-50">
      <a href="https://github.com/hussnainzafar/" target="_blank" rel="noopener noreferrer" 
         className="text-gray-400 hover:text-white transition-colors"
         title="GitHub Profile">
        <FaGithub className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>
      <a href="https://www.linkedin.com/in/hafiz-hussnain-zafar-529816211/" target="_blank" rel="noopener noreferrer"
         className="text-gray-400 hover:text-white transition-colors"
         title="LinkedIn Profile">
        <FaLinkedin className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>
      <a href="https://mail.google.com/mail/?view=cm&fs=1&to=zhussnain19@gmail.com" 
         target="_blank" 
         rel="noopener noreferrer"
         className="text-gray-400 hover:text-white transition-colors"
         title="Send Email">
        <FaEnvelope className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>
      <a href="https://drive.google.com/file/d/1SmwGhQ74LANKGGlVtKKprLLpi94FK_2R/view?usp=sharing" target="_blank" rel="noopener noreferrer"
         className="text-gray-400 hover:text-white transition-colors"
         title="View Resume">
        <FaFilePdf className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>
    </div>
  );
};

export default SocialIcons;
